import React, { useEffect } from 'react';
import { useAuthenticationContext, useAuthenticationContextRequired } from 'nekst-api';
import { useTeamSetupAreasContextRequired } from './TeamSetupAreasContext';
import useSettingsNavigator from '../settingsNavigator';

export function AssignMarketPopupOpenerContent() {
  const teamSetupAreasContext = useTeamSetupAreasContextRequired();
  const authenticationContext = useAuthenticationContextRequired();

  const teamSetupAreas = teamSetupAreasContext.teamSetupAreas;

  const settingsNavigator = useSettingsNavigator();

  useEffect(() => {
    if (authenticationContext.user.hasActiveAccount
      && teamSetupAreas.length === 0
      && !localStorage.getItem('assign-market-popup-opened')
    ) {
      settingsNavigator.openMarketsPage(true);
      localStorage.setItem('assign-market-popup-opened', '1');
    }
  }, [authenticationContext.user.hasActiveAccount, teamSetupAreas.length]);

  return null;
}

export default function AssignMarketPopupOpener() {
  const authenticationContext = useAuthenticationContext();

  useEffect(() => {
    if (!authenticationContext?.user.id) {
      localStorage.removeItem('assign-market-popup-opened');
    }
  }, [authenticationContext?.user.id]);

  if (authenticationContext?.user) {
    return <AssignMarketPopupOpenerContent />;
  } else {
    return null;
  }
}
